import type { History } from "history";
import type { FC, ReactNode } from "react";
import { createContext, useContext } from "react";

interface HistoryContextType {
  history: History;
}

const Default: HistoryContextType = {
  history: null,
};

const HistoryContext = createContext<HistoryContextType>(Default);

const useHistory = () => {
  const { history } = useContext(HistoryContext);

  return history;
};

interface Props {
  history: History;
  children: ReactNode;
}

const HistoryProvider: FC<Props> = ({ children, history }) => {
  return <HistoryContext.Provider value={{ history }}>{children}</HistoryContext.Provider>;
};

export { HistoryProvider, useHistory };
export type { HistoryContextType };
